import { Box, Divider, Skeleton } from "@mui/material";
import React from "react";

export const PaymentMobileLoader = () => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "1rem",
        }}
      >
        <Skeleton variant="rounded" width="100%" height={15} animation="wave" />
        <Skeleton
          variant="rounded"
          width="100%"
          height={15}
          animation="wave"
          sx={{ marginTop: "10px" }}
        />
        <Divider
          sx={{
            margin: "1rem auto",
          }}
        />
        <Skeleton variant="rounded" width="100%" height={15} animation="wave" />
        <Skeleton
          variant="rounded"
          width="100%"
          height={15}
          animation="wave"
          sx={{ marginTop: "10px" }}
        />
        <Skeleton
          variant="rounded"
          width="100%"
          height={140}
          animation="wave"
          sx={{ marginTop: "10px" }}
        />
      </Box>
      <Box
        sx={{
          background: "#fff",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "1rem",
        }}
      >
        <Skeleton
          variant="rounded"
          width="100%"
          height={100}
          animation="wave"
        />
      </Box>
      <Skeleton
        variant="rounded"
        width="100%"
        height={50}
        animation="wave"
        sx={{
          marginTop: "2rem",
        }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={50}
        animation="wave"
        sx={{
          marginTop: "1rem",
        }}
      />
      <Box
        sx={{
          background: "#fff",
          position: "fixed",
          bottom: 0,
          left: 0,
          zIndex: 1100,
          width: "100%",
          padding: "0.5rem",
        }}
      >
        <Skeleton variant="rounded" width="100%" height={20} animation="wave" />
        <Divider sx={{ margin: "0.5rem auto" }} />
        <Skeleton variant="rounded" width="100%" height={20} animation="wave" />
        <Skeleton
          variant="rounded"
          width="100%"
          height={20}
          animation="wave"
          sx={{ marginTop: "0.5rem" }}
        />
        <Divider sx={{ margin: "0.5rem auto" }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Skeleton
            variant="rounded"
            width="45%"
            height={50}
            animation="wave"
          />
          <Skeleton
            variant="rounded"
            width="45%"
            height={50}
            animation="wave"
          />
        </Box>
      </Box>
    </>
  );
};
